module.exports = __webpack_public_path__ + "img/travel-distance-ai.496b8452.png";